import {
    BOPIS_MSG_GET_SUCCESS,
    BOPIS_MSG_GET_FAILURE,
    RESET_BOPIS_MESSAGE,
} from '../actionTypes/BOPISMessageActionTypes';

export default function BOPISMessageReducer(state = {}, action) {
    switch (action.type) {
        case BOPIS_MSG_GET_SUCCESS:
            return { ...action.payload };
        case BOPIS_MSG_GET_FAILURE:
            return {};
        case RESET_BOPIS_MESSAGE:
            return {};
        default:
            return state;
    }
}
